import { Toolbar } from '@mui/x-data-grid-pro';
import { StyledQuickFilter } from '@components/DataGrid/StyledComponents';

/**
 * Toolbar that sits on top of the Street Turn data grid and displays actions available.
 */
export default function StreetTurnGridToolbar() {
	return (
		<Toolbar>
			<StyledQuickFilter
				placeholder='Filter by Keyword'
				debounceMs={300}
				autoFocus
				disabled={false}
				defaultExpanded={true}
			/>
		</Toolbar>
	);
}
